import type { SidePanel } from '../types';

export const Invest: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./InvestPanel.vue')),
};
